import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import clsx from 'clsx';
import { SelectDatepicker } from 'components/shared/SelectDatepicker';
import styles from './Input.module.scss';
import dateStyles from './BirthdayInput.module.scss';

type InputProps = {
  className?: string,
  onChange?: (value: Date | null) => void,
  value?: Date | null,
  disabled?: boolean,
  error?: boolean,
  errorMessage?: string,
  isDefaultValue?: boolean,
  white?: boolean,
}

function BirthdayInput({
  className = '',
  onChange = () => {},
  value = null,
  isDefaultValue,
  disabled = false,
  error = false,
  errorMessage = '',
  white,
}: InputProps) {
  const calendarRef = useRef(null);
  const [selectValue, setSelectValue] = useState<Date | null>();

  useEffect(() => {
    if (value) {
      setSelectValue(value)
    }
  }, [value]);

  const onDateChange = useCallback((date: Date | null) => {
    if (date) {
      onChange(date)
    }
    setSelectValue(date);
  }, []);

  const onDateFirstChange = useCallback((date: Date | null) => {
    setSelectValue(date);
  }, []);

  if (isDefaultValue) {
    return (
      <>
        <div
          className={clsx(
            dateStyles.containerDate,
            className,
          )}
          ref={calendarRef}
        >
          {
          selectValue
            ? (
              <SelectDatepicker
                className={dateStyles.selectCalendar}
                selectedDate={selectValue}
                onDateChange={onDateChange}
                disabled={disabled}
                white={white}
              />
            )
            : (
              <SelectDatepicker
                className={dateStyles.selectCalendar}
                selectedDate={value}
                onDateChange={onDateFirstChange}
                disabled={disabled}
                white={white}
              />
            )
        }

        </div>
        {(error && errorMessage) && (
        <div className={styles.errorMessage}>{errorMessage}</div>
        )}
      </>
    )
  }

  return (
    <>
      <div
        className={clsx(
          dateStyles.containerDate,
          className,
        )}
        ref={calendarRef}
      >
        <SelectDatepicker
          className={dateStyles.selectCalendar}
          selectedDate={selectValue}
          onDateChange={onDateChange}
          disabled={disabled}
          white={white}
        />

      </div>
      {(error && errorMessage) && (
        <div className={styles.errorMessage}>{errorMessage}</div>
      )}
    </>
  )
}

export default BirthdayInput
